import DOMPurify from 'dompurify';

export function composerSanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_ATTR: ['class'],
  });
}

// Parses without running: a detached div still loads `<img onerror>` and fires it; a DOMParser document never does.
export function htmlToPlainText(html: string | null | undefined): string {
  return new DOMParser().parseFromString(html ?? '', 'text/html').body.textContent ?? '';
}

// Keeps class and data-* (Quill mentions need data-id / data-denotation-char) and Quill's link target.
export function sanitizeRichTextHtml(html: string | null | undefined): string {
  return DOMPurify.sanitize(html ?? '', { ADD_ATTR: ['target'] });
}
